import './Home.css';
import { useEffect, useState } from 'react';
import { supabase } from '../supabaseClient';
import profileimg from "../Assets/Images/dp-profile.jpg";
import Skeleton from './Skeleton';

const About = () => {
  const [aboutData, setAboutData] = useState(null);
  const [skills, setSkills] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch About Data
        const { data: about, error: aboutError } = await supabase
          .from('about')
          .select('*')
          .single();
        
        if (aboutError && aboutError.code !== 'PGRST116') throw aboutError;
        if (about) setAboutData(about);

        // Fetch Skills Data
        const { data: skillsData, error: skillsError } = await supabase
          .from('skills')
          .select('*')
          .order('id');
        
        if (skillsError) throw skillsError;
        if (skillsData) setSkills(skillsData);

      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  // Fallback data for About
  const data = aboutData || {
    title: "Web Developer. & Software Developer",
    short_description: "I am a 4th-year B.Tech student in the Division of Computer Science at School of Engineering CUSAT. I love coding because I enjoy the joy of learning, which springs from the nonrepeating nature of the task and relish the sheer delight of exploring new things.",
    long_description: "To succeed in an environment of growth and excellence to earn a job which provides me job satisfaction and self-development and help me achieve personal as well as an organizational goal. Also to obtain a responsible, challenging and awarding position in a software development organization with an established track record where my skills, ability and technical ability can be utilized.",
    birthday: "23 May 2000",
    website: "https://devaprasadnm.github.io",
    phone: "7306290566",
    city: "Kannur,Kerala",
    age: 22,
    degree: "B.Tech",
    email: "devaprasadmohanan@gmail.com",
    freelance: "Available",
    profile_image: profileimg
  };

  // Fallback data for Skills
  const defaultSkills = [
    { name: "HTML", percentage: 100 },
    { name: "CSS", percentage: 90 },
    { name: "JavaScript", percentage: 75 },
    { name: "PYTHON", percentage: 80 },
    { name: "WordPress/CMS", percentage: 90 },
    { name: "Photoshop", percentage: 55 }
  ];

  const displaySkills = skills.length > 0 ? skills : defaultSkills;

  if (loading) {
    return (
      <section id="about" className="about">
        <div className="container" data-aos="fade-up">
          <div className="section-title">
            <h2>About</h2>
            <Skeleton type="text" />
            <Skeleton type="text" />
          </div>
          <div className="row mb-4">
            <div className="col-lg-12">
              <Skeleton type="title" />
              <Skeleton type="text" />
              <Skeleton type="text" />
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6">
              <Skeleton type="block" />
            </div>
            <div className="col-lg-6">
              <Skeleton type="block" />
            </div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <>
      <section id="about" className="about">
        <div className="container" data-aos="fade-up">

          <div className="section-title">
            <h2>About</h2>
            <p>{data.long_description}</p>
          </div>

          <div className="row mb-4">
            <div className="col-lg-12 content" data-aos="fade-up">
              <h3>{data.title}</h3>
              <p className="fst-italic">
                {data.short_description}
              </p>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-6 skills" data-aos="fade-right">
              {displaySkills.map((skill, index) => (
                <div className="progress" key={index} data-aos="fade-up" data-aos-delay={index * 50}>
                  <span className="skill">{skill.name} <i className="val">{skill.percentage}%</i></span>
                  <div className="progress-bar-wrap">
                    <div className="progress-bar" role="progressbar" style={{width: `${skill.percentage}%`}} aria-valuenow={skill.percentage} aria-valuemin="0" aria-valuemax="100"></div>
                  </div>
                </div>
              ))}
            </div>
            <div className="col-lg-6 pt-4 pt-lg-0 content" data-aos="fade-left">
              <div className="row">
                <div className="col-lg-6">
                  <ul>
                    <li data-aos="fade-up" data-aos-delay="100"><i className="bi bi-chevron-right"></i> <strong>Birthday:</strong> <span>{data.birthday}</span></li>
                    <li data-aos="fade-up" data-aos-delay="200"><i className="bi bi-chevron-right"></i> <strong>Website:</strong> <span>{data.website}</span></li>
                    <li data-aos="fade-up" data-aos-delay="300"><i className="bi bi-chevron-right"></i> <strong>Phone:</strong> <span>{data.phone}</span></li>
                    <li data-aos="fade-up" data-aos-delay="400"><i className="bi bi-chevron-right"></i> <strong>City:</strong> <span>{data.city}</span></li>
                  </ul>
                </div>
                <div className="col-lg-6">
                  <ul>
                    <li data-aos="fade-up" data-aos-delay="500"><i className="bi bi-chevron-right"></i> <strong>Age:</strong> <span>{data.age}</span></li>
                    <li data-aos="fade-up" data-aos-delay="600"><i className="bi bi-chevron-right"></i> <strong>Degree:</strong> <span>{data.degree}</span></li>
                    <li data-aos="fade-up" data-aos-delay="700"><i className="bi bi-chevron-right"></i> <strong>Email:</strong> <span>{data.email}</span></li>
                    <li data-aos="fade-up" data-aos-delay="800"><i className="bi bi-chevron-right"></i> <strong>Freelance:</strong> <span>{data.freelance}</span></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

        </div>
      </section>
    </>
  );
};

export default About;